import { Format } from "./core/elements/format"
import { Annotation } from "./tools/index"

let CheckBox = function (chart, text, checked) {
	Annotation.call(this, chart)

	this.transparent = true
	this.text = text
	this.checked = checked || true
	this.margins.left = 10

	this.cursor = "pointer"

	this.check = new Format(chart)
	this.check.fill = "white"

	this.draw = function () {
		Annotation.prototype.draw.call(this)

		var c = this.chart.ctx,
			x = this.position.x + 2

		var h = this.bounds.height * 0.6,
			y = this.position.y + (this.bounds.height - h) * 0.4

		this.check.rectangle(x, y, h, h)

		if (this.checked) {
			c.beginPath()
			c.moveTo(x + 3, y + 5)
			c.lineTo(x + 4, y + 8)
			c.lineTo(x + 7, y + 2)
			this.check.stroke.prepare()
			c.stroke()
		}
	}

	this.chart.canvas.addEventListener("touchstart", () => {})
	this.onclick = function (/*a,x,y*/) {
		this.checked = !this.checked
		if (this.onchange) this.onchange(this)
		return true
	}
}

CheckBox.prototype = new Annotation()

export { CheckBox }
